import { TopToolbar } from 'react-admin';
import { PeriodFilterInput } from '@/components/global/filters/PeriodFilterInput';
import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import CustomFilterButton from '@/components/global/filters/CustomFilterButton';

export const AnalyticsListActions = ({ onCustomPeriodSelect }) => {
    const theme = useTheme();
    return (
        <TopToolbar
            sx={{
                [theme.breakpoints.down('md')]: {
                    justifyContent: 'flex-start',
                },
            }}
        >
            <PeriodFilterInput onCustomPeriodSelect={onCustomPeriodSelect} />
            <CustomFilterButton />
        </TopToolbar>
    );
};

AnalyticsListActions.propTypes = {
    onCustomPeriodSelect: PropTypes.func,
};
